/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import cx from 'classnames';

import { DatePickerActions, SINGLE_DATE_CLOSE_ACTION_LABELS } from './DatePickerActions';
import { SingleDatePanel } from './SingleDatePanel';
import type { DatePickerVariant } from './DatePicker.types';
import type { SingleDatePickerDraft } from './useSingleDatePickerDraft';

import styles from './DatePickerContent.module.scss';

interface SingleDatePickerContentProps {
    draft: SingleDatePickerDraft;
    variant: DatePickerVariant;
}

/**
 * Body of the single-date picker, independent of the popover or drawer that wraps it.
 */
export function SingleDatePickerContent({
    draft,
    variant,
}: SingleDatePickerContentProps) {
    const { date, setDate, hasDates, closeAction, onClearDates, onOpenChange } = draft;

    return (
        <div
            className={cx(styles.PopupContent, styles.DatesPopupContent, {
                [styles.isPopover]: variant === 'popover',
                [styles.isDrawer]: variant === 'drawer',
            })}
        >
            <div className={styles.Body}>
                <SingleDatePanel date={date} setDate={setDate} variant={variant} />
            </div>

            <DatePickerActions
                closeAction={closeAction}
                closeActionLabels={SINGLE_DATE_CLOSE_ACTION_LABELS}
                onReset={() => onClearDates({ commit: false })}
                isResetDisabled={!hasDates}
                resetLabel="Clear Date"
                onApply={() => onOpenChange(false)}
                variant={variant}
            />
        </div>
    );
}
